// 성경학교 자료실 연도별 게시판
export const BIBLE_SCHOOL_LIBRARY_BOARDS = [
  { id: 14, year: "2026", name: "2026년" },
  { id: 15, year: "2025", name: "2025년" },
  { id: 16, year: "2024", name: "2024년" },
  { id: 17, year: "2023", name: "2023년" },
  { id: 18, year: "2022", name: "2022년" },
  { id: 19, year: "2021", name: "2021년" },
  { id: 20, year: "2020", name: "2020년" },
  { id: 21, year: "2019", name: "2019년" },
  { id: 22, year: "2018", name: "2018년" },
  { id: 23, year: "2017", name: "2017년" },
  { id: 24, year: "before", name: "2017년 이전" },
];

export const isBibleSchoolLibraryBoard = (boardId) =>
  BIBLE_SCHOOL_LIBRARY_BOARDS.some((board) => board.id === Number(boardId));

export const getBibleSchoolLibraryPath = (boardId) => {
  const board = BIBLE_SCHOOL_LIBRARY_BOARDS.find(
    (item) => item.id === Number(boardId),
  );
  const year = board?.year || BIBLE_SCHOOL_LIBRARY_BOARDS[0].year;
  return `/bible-school?tab=library&year=${year}`;
};
